// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-ballot-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    padding: 20px;
    backdrop-filter: blur(6px);
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.sub-ballot-modal-content {
    background: linear-gradient(145deg, #1e1e1e 0%, #252525 100%);
    border-radius: 20px;
    max-width: 650px;
    width: 100%;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.6),
        0 0 1px rgba(255, 255, 255, 0.1) inset;
    animation: modalSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    border: 1px solid rgba(255, 255, 255, 0.05);
}

@keyframes modalSlideUp {
    from {
        opacity: 0;
        transform: translateY(80px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.sub-ballot-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 28px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.2);
}

.sub-ballot-modal-header h3 {
    margin: 0;
    font-size: 19px;
    color: #fff;
    font-weight: 600;
    letter-spacing: 0.3px;
}

.sub-ballot-back-btn,
.sub-ballot-close-btn {
    background: transparent;
    border: none;
    color: #aaa;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 10px;
    transition: all 0.25s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
    font-weight: 500;
}

.sub-ballot-back-btn:hover,
.sub-ballot-close-btn:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    transform: translateX(-2px);
}

.sub-ballot-close-btn:hover {
    transform: translateX(0) scale(1.1);
}

.sub-ballot-modal-body {
    padding: 28px;
    overflow-y: auto;
    flex: 1 1;
}

.sub-ballot-modal-body::-webkit-scrollbar {
    width: 8px;
}

.sub-ballot-modal-body::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.02);
    border-radius: 10px;
}

.sub-ballot-modal-body::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
}

.sub-ballot-modal-body::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.25);
}

.parent-choice-banner {
    background: linear-gradient(135deg, #2a4a2a 0%, #1e3a1e 100%);
    padding: 18px 20px;
    border-radius: 14px;
    margin-bottom: 28px;
    border-left: 5px solid #4caf50;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.15);
    position: relative;
    overflow: hidden;
}

.parent-choice-banner::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(76, 175, 80, 0.1) 50%,
            transparent 100%);
    animation: shimmer 3s infinite;
}

@keyframes shimmer {

    0%,
    100% {
        transform: translateX(-100%);
    }

    50% {
        transform: translateX(100%);
    }
}

.parent-choice-label {
    display: block;
    font-size: 12px;
    color: #90c990;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;
}

.parent-choice-value {
    display: block;
    font-size: 17px;
    color: #fff;
    font-weight: 600;
    line-height: 1.4;
    position: relative;
}

.sub-ballot-title {
    font-size: 24px;
    color: #fff;
    margin-bottom: 20px;
    line-height: 1.5;
    font-weight: 700;
}

.sub-ballot-description {
    color: #bbb;
    margin-bottom: 28px;
    line-height: 1.7;
    font-size: 15px;
}

.sub-ballot-options-container {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.sub-ballot-option-item {
    display: flex;
    align-items: center;
    padding: 18px 20px;
    background: rgba(255, 255, 255, 0.03);
    border: 2px solid transparent;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
}

.sub-ballot-option-item:hover:not(.voted) {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(76, 175, 80, 0.3);
    transform: translateX(4px);
    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.1);
}

.sub-ballot-option-item.selected {
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.15) 0%, rgba(76, 175, 80, 0.08) 100%);
    border-color: #4caf50;
    transform: translateX(6px);
    box-shadow: 0 6px 25px rgba(76, 175, 80, 0.2);
}

.sub-ballot-option-item.voted {
    cursor: default;
    background: rgba(40, 40, 40, 0.5);
}

.sub-ballot-option-item.voted.selected {
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.2) 0%, rgba(76, 175, 80, 0.12) 100%);
    border-color: #4caf50;
}

.sub-ballot-option-item input[type="radio"] {
    width: 22px;
    height: 22px;
    margin-right: 16px;
    cursor: pointer;
    accent-color: #4caf50;
    flex-shrink: 0;
}

.sub-ballot-option-item.voted input[type="radio"] {
    cursor: default;
}

.sub-ballot-option-text {
    color: #fff;
    font-size: 16px;
    flex: 1 1;
    font-weight: 500;
    line-height: 1.5;
}

.percentage-display {
    margin-left: 16px;
    font-size: 18px;
    font-weight: 700;
    color: #4caf50;
    min-width: 50px;
    text-align: right;
    flex-shrink: 0;
}

.sub-ballot-progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 0 0 12px 12px;
    overflow: hidden;
}

.sub-ballot-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #4caf50 0%, #66bb6a 100%);
    transition: width 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 0 10px rgba(76, 175, 80, 0.5);
}

.sub-ballot-modal-footer {
    padding: 20px 28px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    gap: 14px;
    justify-content: flex-end;
    background: rgba(0, 0, 0, 0.2);
}

.sub-ballot-cancel-btn,
.sub-ballot-submit-btn {
    padding: 14px 28px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.sub-ballot-cancel-btn {
    background: transparent;
    color: #aaa;
    border: 2px solid rgba(255, 255, 255, 0.15);
}

.sub-ballot-cancel-btn:hover {
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
}

.sub-ballot-submit-btn {
    background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
    color: #fff;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.sub-ballot-submit-btn:hover:not(:disabled) {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.45);
}

.sub-ballot-submit-btn:active:not(:disabled) {
    transform: translateY(-1px);
}

.sub-ballot-submit-btn:disabled {
    background: linear-gradient(135deg, #555 0%, #444 100%);
    color: #888;
    cursor: not-allowed;
    box-shadow: none;
}

/* Mobile responsive */
@media (max-width: 768px) {
    .sub-ballot-modal-content {
        max-width: 100%;
        max-height: 100vh;
        border-radius: 0;
        height: 100vh;
    }

    .sub-ballot-modal-header {
        padding: 16px 20px;
    }

    .sub-ballot-modal-header h3 {
        font-size: 17px;
    }

    .sub-ballot-modal-body {
        padding: 20px;
    }

    .parent-choice-banner {
        padding: 14px 16px;
        margin-bottom: 22px;
    }

    .parent-choice-value {
        font-size: 16px;
    }

    .sub-ballot-title {
        font-size: 21px;
        margin-bottom: 16px;
    }

    .sub-ballot-description {
        font-size: 14px;
        margin-bottom: 22px;
    }

    .sub-ballot-option-item {
        padding: 14px 16px;
    }

    .sub-ballot-option-text {
        font-size: 15px;
    }

    .sub-ballot-modal-footer {
        padding: 16px 20px;
        flex-direction: column-reverse;
    }

    .sub-ballot-cancel-btn,
    .sub-ballot-submit-btn {
        width: 100%;
        padding: 16px;
    }
}

/* Tablet landscape */
@media (min-width: 769px) and (max-width: 1024px) {
    .sub-ballot-modal-content {
        max-width: 90%;
    }
}

/* Dark mode adjustments */
@media (prefers-color-scheme: dark) {
    .sub-ballot-modal-content {
        border-color: rgba(255, 255, 255, 0.08);
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/SubBallotModal/SubBallotModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB;8CAC0C;IAC1C,8DAA8D;IAC9D,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kDAAkD;IAClD,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,oCAAoC;IACpC,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6DAA6D;IAC7D,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;;6BAGyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI;;QAEI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,sDAAsD;IACtD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,6FAA6F;IAC7F,qBAAqB;IACrB,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,4FAA4F;IAC5F,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,qCAAqC;IACrC,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,4DAA4D;IAC5D,wDAAwD;IACxD,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sDAAsD;IACtD,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,6DAA6D;IAC7D,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uDAAuD;IACvD,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,8BAA8B;IAClC;;IAEA;;QAEI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA,qBAAqB;AACrB;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,0BAA0B;AAC1B;IACI;QACI,uCAAuC;IAC3C;AACJ","sourcesContent":[".sub-ballot-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.75);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 99999;\n    padding: 20px;\n    backdrop-filter: blur(6px);\n    animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.sub-ballot-modal-content {\n    background: linear-gradient(145deg, #1e1e1e 0%, #252525 100%);\n    border-radius: 20px;\n    max-width: 650px;\n    width: 100%;\n    max-height: 90vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.6),\n        0 0 1px rgba(255, 255, 255, 0.1) inset;\n    animation: modalSlideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n@keyframes modalSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(80px) scale(0.95);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n.sub-ballot-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 28px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.sub-ballot-modal-header h3 {\n    margin: 0;\n    font-size: 19px;\n    color: #fff;\n    font-weight: 600;\n    letter-spacing: 0.3px;\n}\n\n.sub-ballot-back-btn,\n.sub-ballot-close-btn {\n    background: transparent;\n    border: none;\n    color: #aaa;\n    cursor: pointer;\n    padding: 8px 12px;\n    border-radius: 10px;\n    transition: all 0.25s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.sub-ballot-back-btn:hover,\n.sub-ballot-close-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #fff;\n    transform: translateX(-2px);\n}\n\n.sub-ballot-close-btn:hover {\n    transform: translateX(0) scale(1.1);\n}\n\n.sub-ballot-modal-body {\n    padding: 28px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.sub-ballot-modal-body::-webkit-scrollbar {\n    width: 8px;\n}\n\n.sub-ballot-modal-body::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0.02);\n    border-radius: 10px;\n}\n\n.sub-ballot-modal-body::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 10px;\n}\n\n.sub-ballot-modal-body::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.25);\n}\n\n.parent-choice-banner {\n    background: linear-gradient(135deg, #2a4a2a 0%, #1e3a1e 100%);\n    padding: 18px 20px;\n    border-radius: 14px;\n    margin-bottom: 28px;\n    border-left: 5px solid #4caf50;\n    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.15);\n    position: relative;\n    overflow: hidden;\n}\n\n.parent-choice-banner::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(76, 175, 80, 0.1) 50%,\n            transparent 100%);\n    animation: shimmer 3s infinite;\n}\n\n@keyframes shimmer {\n\n    0%,\n    100% {\n        transform: translateX(-100%);\n    }\n\n    50% {\n        transform: translateX(100%);\n    }\n}\n\n.parent-choice-label {\n    display: block;\n    font-size: 12px;\n    color: #90c990;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    font-weight: 600;\n}\n\n.parent-choice-value {\n    display: block;\n    font-size: 17px;\n    color: #fff;\n    font-weight: 600;\n    line-height: 1.4;\n    position: relative;\n}\n\n.sub-ballot-title {\n    font-size: 24px;\n    color: #fff;\n    margin-bottom: 20px;\n    line-height: 1.5;\n    font-weight: 700;\n}\n\n.sub-ballot-description {\n    color: #bbb;\n    margin-bottom: 28px;\n    line-height: 1.7;\n    font-size: 15px;\n}\n\n.sub-ballot-options-container {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.sub-ballot-option-item {\n    display: flex;\n    align-items: center;\n    padding: 18px 20px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 2px solid transparent;\n    border-radius: 14px;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n.sub-ballot-option-item:hover:not(.voted) {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(76, 175, 80, 0.3);\n    transform: translateX(4px);\n    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.1);\n}\n\n.sub-ballot-option-item.selected {\n    background: linear-gradient(135deg, rgba(76, 175, 80, 0.15) 0%, rgba(76, 175, 80, 0.08) 100%);\n    border-color: #4caf50;\n    transform: translateX(6px);\n    box-shadow: 0 6px 25px rgba(76, 175, 80, 0.2);\n}\n\n.sub-ballot-option-item.voted {\n    cursor: default;\n    background: rgba(40, 40, 40, 0.5);\n}\n\n.sub-ballot-option-item.voted.selected {\n    background: linear-gradient(135deg, rgba(76, 175, 80, 0.2) 0%, rgba(76, 175, 80, 0.12) 100%);\n    border-color: #4caf50;\n}\n\n.sub-ballot-option-item input[type=\"radio\"] {\n    width: 22px;\n    height: 22px;\n    margin-right: 16px;\n    cursor: pointer;\n    accent-color: #4caf50;\n    flex-shrink: 0;\n}\n\n.sub-ballot-option-item.voted input[type=\"radio\"] {\n    cursor: default;\n}\n\n.sub-ballot-option-text {\n    color: #fff;\n    font-size: 16px;\n    flex: 1;\n    font-weight: 500;\n    line-height: 1.5;\n}\n\n.percentage-display {\n    margin-left: 16px;\n    font-size: 18px;\n    font-weight: 700;\n    color: #4caf50;\n    min-width: 50px;\n    text-align: right;\n    flex-shrink: 0;\n}\n\n.sub-ballot-progress-bar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 5px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 0 0 12px 12px;\n    overflow: hidden;\n}\n\n.sub-ballot-progress-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #4caf50 0%, #66bb6a 100%);\n    transition: width 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);\n    box-shadow: 0 0 10px rgba(76, 175, 80, 0.5);\n}\n\n.sub-ballot-modal-footer {\n    padding: 20px 28px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    gap: 14px;\n    justify-content: flex-end;\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.sub-ballot-cancel-btn,\n.sub-ballot-submit-btn {\n    padding: 14px 28px;\n    border-radius: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.sub-ballot-cancel-btn {\n    background: transparent;\n    color: #aaa;\n    border: 2px solid rgba(255, 255, 255, 0.15);\n}\n\n.sub-ballot-cancel-btn:hover {\n    background: rgba(255, 255, 255, 0.08);\n    color: #fff;\n    border-color: rgba(255, 255, 255, 0.3);\n    transform: translateY(-2px);\n}\n\n.sub-ballot-submit-btn {\n    background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);\n    color: #fff;\n    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);\n}\n\n.sub-ballot-submit-btn:hover:not(:disabled) {\n    transform: translateY(-3px);\n    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.45);\n}\n\n.sub-ballot-submit-btn:active:not(:disabled) {\n    transform: translateY(-1px);\n}\n\n.sub-ballot-submit-btn:disabled {\n    background: linear-gradient(135deg, #555 0%, #444 100%);\n    color: #888;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n    .sub-ballot-modal-content {\n        max-width: 100%;\n        max-height: 100vh;\n        border-radius: 0;\n        height: 100vh;\n    }\n\n    .sub-ballot-modal-header {\n        padding: 16px 20px;\n    }\n\n    .sub-ballot-modal-header h3 {\n        font-size: 17px;\n    }\n\n    .sub-ballot-modal-body {\n        padding: 20px;\n    }\n\n    .parent-choice-banner {\n        padding: 14px 16px;\n        margin-bottom: 22px;\n    }\n\n    .parent-choice-value {\n        font-size: 16px;\n    }\n\n    .sub-ballot-title {\n        font-size: 21px;\n        margin-bottom: 16px;\n    }\n\n    .sub-ballot-description {\n        font-size: 14px;\n        margin-bottom: 22px;\n    }\n\n    .sub-ballot-option-item {\n        padding: 14px 16px;\n    }\n\n    .sub-ballot-option-text {\n        font-size: 15px;\n    }\n\n    .sub-ballot-modal-footer {\n        padding: 16px 20px;\n        flex-direction: column-reverse;\n    }\n\n    .sub-ballot-cancel-btn,\n    .sub-ballot-submit-btn {\n        width: 100%;\n        padding: 16px;\n    }\n}\n\n/* Tablet landscape */\n@media (min-width: 769px) and (max-width: 1024px) {\n    .sub-ballot-modal-content {\n        max-width: 90%;\n    }\n}\n\n/* Dark mode adjustments */\n@media (prefers-color-scheme: dark) {\n    .sub-ballot-modal-content {\n        border-color: rgba(255, 255, 255, 0.08);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
